<template>
  <div id="wrapper-mobile-size">
    <div class="mobile-size">
      <img :src="require('@/assets/images/pages/vote-success.svg')">
      <span v-if="kandidat !== null" style="margin-bottom: 16px; color: #000; margin-bottom: 16px;">Terimakasih telah
        memilih <b>{{ kandidat.nama }}</b>,
        no urut <b>{{ kandidat.no_urut }}</b><br />
        <span style="font-size: 12px; margin-top: 5px; display: block;">⚠️ informasi rahasia dan pribadi, tidak untuk
          disebarluaskan</span></span>
      <span v-if="kandidat === null" style="margin-bottom: 16px; color: #000; margin-bottom: 16px;">Pilihan kandidat
        telah ditampilkan sebelumnya
      </span>
      <div class="greetings">
        Selamat, <span>{{ $store.state.user.userLoggedIn.nama_panjang }}!</span>
      </div>
      <div class="info">
        Anda sudah melakukan E-Vote Ketua Umum ILUNI UI periode 2025-2028 di tanggal {{ voteDate }} jam {{ voteTime }}.
        Terima kasih atas partisipasi Anda.
      </div>
      <div class="logout" @click="logout">
        <feather-icon class="mr-25" icon="LogOutIcon" />
        <span>Logout</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media (max-width: 640px) {
  .mobile-size {
    width: 100vw !important;
  }

  .logout {
    display: none !important;
  }
}

#wrapper-mobile-size {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: #E5E5E5;
}

.mobile-size {
  width: 360px;
  height: 100vh;
  background-color: #F9F9F9;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 28px;
}

.mobile-size img {
  height: 160px;
  width: 160px;
  margin-bottom: 36px;
}

.mobile-size .greetings {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */

  text-align: center;

  color: #1B1B1B;
}

.mobile-size .greetings span {
  color: #4FBBEA;
}

.mobile-size .info {
  margin-top: 12px;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;

  /* primary */

  color: #1B1B1B;
}

.logout {
  position: absolute;
  bottom: 90px;
  background: #FFFFFF;
  right: 24px;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 20px;
  color: #1B1B1B;
}
</style>

<script>
import API from '@/api'
import getDataFromStorage from '@/helpers/getDataFromStorage'
import { BAlert } from 'bootstrap-vue'

export default {
  components: {
    BAlert
  },
  computed: {
    voteDate() {
      const [datePart, timePart] = this.voteAt.split(" ") || getDataFromStorage().voteAt.split(" ");
      return datePart;
    },
    voteTime() {
      const [datePart, timePart] = this.voteAt.split(" ") || getDataFromStorage().voteAt.split(" ");
      const [hours, minutes] = timePart.split(":");
      return `${hours}:${minutes}`;
    },
    countDown() {
      setTimeout(() => {
        this.kandidat = null;
        localStorage.removeItem("kandidat");
      }, 3000)
    }
  },
  data() {
    return {
      voteAt: '',
      kandidat: JSON.parse(localStorage.getItem("kandidat")) || null
    }
  },
  mounted() {
    this.getValidate()
    this.countDown();
  },
  methods: {
    async logout() {
      this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
      await this.$store.dispatch('user/logout')

      // Redirect to login page
      window.location.replace('/login/tps')
    },
    async getValidate() {
      try {
        const { data } = await API.evote.validateVoter()
        this.voteAt = data.voting_datetime
      } catch (error) {
        console.error('Error validating voter:', error)
      }
    }
  },
}
</script>
